import React, { useEffect, useRef, useState } from "react";
import Header from "../common/Header";
import $ from "jquery";
import { Link, useNavigate, useParams } from "react-router-dom";
import useAuth from "../../hooks/useAuth";
import { convertDataToWarehouseSheet } from "../helpers/print";
import Toastify from "../common/Toastify";
import EnterOrderList from "./EnterOrderList";
import Select from "react-select";
import { dateFormat } from "../helpers/date";
import DeleteItemModal from "../../modal/DeleteItemModal";
import { GETREQUEST, POSTREQUEST } from "../helpers/ServiceRequest";
import { generateWarehousePdf } from "../Pdfs/warehouseSheet";
import { addTrailingZeros } from "../helpers/common";
function ViewEditOrder() {
  const [showDeleteOrderModal, setShowDeleteOrderModal] = useState(false);
  const [orderDate, setOrderDate] = useState("");
  const [customerCodeValue, setCustomerCodeValue] = useState("");
  const [customerNameValue, setCustomerNameValue] = useState("");
  const [customerCategory, setCustomerCategory] = useState("");
  const [customersCode, setCustomersCode] = useState([]);
  const [customeCodeErr, setCustomeCodeErr] = useState(false);
  const [BuyerCode, setBuyerCode] = useState("");
  const [contactName, setContactName] = useState("");
  const [phoneNo, setPhoneNo] = useState("");
  const [poNumber, setPoNumber] = useState("");
  const [orderNotes, setOrderNotes] = useState("");
  const [deliveryInstructions, setDeliveryInstructions] = useState("");
  const [orderDetails, setOrderDetails] = useState([]);
  const [orderDErr, setOrderDErr] = useState(false);
  const [products, setProducts] = useState([]);
  const [agents, setAgents] = useState([]);
  const [units, setUnits] = useState([]);
  const [customerId, setcustomerId] = useState("");
  const [orderItemsList, setOrderItemsList] = useState([]);
  const [message, setMessage] = useState('');
  const [messageType, setMessageType] = useState('');
  const [disabledBtn, setDisabledBtn] = useState(false);
  const [orderDetailsData, setOrderDetailsData] = useState(false);
  const [isFetchCustomer, setIsFetchCustomer] = useState(false);

  let navigate = useNavigate();
  const { id } = useParams();
  const { user } = useAuth();

  const customStyles = {
    option: (provided, state) => ({
      ...provided,
      color: "gray",
      backgroundColor: state.isSelected ? "#01B1E3" : "#fff",
      zIndex: 9999,
    }),
  };

  const CustomOption = (props) => {
    return (
      <div
        className=" css-iunu0q-option"
        style={{ backgroundColor: props.isFocused ? "#01B1E3" : "#fff", color: "gray", zIndex: 9999, padding: " 8px 12px", cursor: "default", display: "block", fontSize: "inherit", width: "100%" }}
        {...props.innerProps}
        ref={props.innerRef}
      >
        {props.label}
      </div>
    )
  }

  // fetch Customers Function
  const fetchCustomers = async () => {
    let URL = process.env.REACT_APP_API_URL + `/search-customer?orderDate=${orderDate}`;
    let response = await GETREQUEST(URL, user.jwtToken)
    if (response?.data) {
      let cnList = [];
      let ccList = [];
      let data = response.data;
      data.forEach((item) => {
        cnList = [...cnList, { label: item.CustomerName, value: item.CustomerID, ...item }];
        ccList = [...ccList, { label: item.CustomerCode, value: item.CustomerID, ...item }];
      });
      ccList.sort((a, b) => a.label.localeCompare(b.label));
      setCustomersCode(ccList);
      return ccList;
    }
  }

  const fetchProducts = async (CustomerID) => {
    if (CustomerID) {
      let PURL = process.env.REACT_APP_API_URL + `/search-order-product/${CustomerID}`;
      let productResponse = await GETREQUEST(PURL, user.jwtToken);

      if (productResponse?.data) {
        setProducts(productResponse.data)
      }
    }
  }

  useEffect(() => {
    var headerHeight = $("header").outerHeight();
    var mainHeight = $(window).height() - headerHeight;
    $("main").height(mainHeight);
    $("main").css("margin-top", headerHeight + "px");

    var tableRow = ".table-form thead > tr";

    $(tableRow).on("focusin", function () {
      $(this).addClass("focus-tr");
    });

    $(tableRow).on("focusout", function () {
      $(this).removeClass("focus-tr");
    });
  });

  useEffect(() => {
    const fetchData = async () => {
      let unitListData = [];
      let commanURL = process.env.REACT_APP_API_URL + "/get-comman-all-for-product";
      let orderUrl = process.env.REACT_APP_API_URL + "/get-order/" + id;

      let commanResponse = await GETREQUEST(commanURL, user.jwtToken);
      let orderResponse = await GETREQUEST(orderUrl, user.jwtToken);

      if (commanResponse?.data) {
        let commanResponseData = commanResponse.data;
        let list = [];
        commanResponseData.agent.forEach((item) => {
          list = [...list, { label: item.AgentCode, value: item.AgentID }];
        });
        setAgents(list);

        commanResponseData.units.forEach((item) => {
          unitListData = [...unitListData, { label: item.UnitName, value: item.UnitID }];
        });
        setUnits(unitListData);
      }

      if (orderResponse?.data) {
        let orderResponseData = orderResponse.data;
        setOrderDetailsData(orderResponseData);
        await onCustomerChange(orderResponseData, unitListData);
        await fetchProducts(orderResponseData.CustomerID)
      }
    }
    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      let customerCodeData = await fetchCustomers();
      const currentSelectedCustomer = customerCodeData.find((customerData) => customerData.value == customerCodeValue.value);
      let redirectOrderId = currentSelectedCustomer?.tblOrders[0]?.OrderId || null;
      if (redirectOrderId) {
        let orderUrl = process.env.REACT_APP_API_URL + "/get-order/" + redirectOrderId;
        let orderResponse = await GETREQUEST(orderUrl, user.jwtToken);
        navigate(`/view-edit-order/${redirectOrderId}`)
        setOrderDetailsData(orderResponse?.data);
        await onCustomerChange(orderResponse?.data, units);
      }
    }
    if (isFetchCustomer) {
      fetchData();
    } else if (orderDate) {
      fetchCustomers();
    }

  }, [orderDate]);

  const onCustomerChange = async (orderResponseData, unitListData, customerData = null) => {
    let customerObj = customerData ? customerData : orderResponseData?.tblCustomer;
    let updatedCustomerData = { label: customerObj?.CustomerCode, value: customerObj?.CustomerID, ...customerObj }
    setCustomerCodeValue(updatedCustomerData)
    setCustomerNameValue(updatedCustomerData.CustomerName)
    setBuyerCode(updatedCustomerData.BuyerCode)
    setPhoneNo(updatedCustomerData.CustomerContact)
    setContactName(updatedCustomerData.CustomerName)
    setcustomerId(updatedCustomerData.CustomerID);
    let customerCategory = updatedCustomerData.Category;
    setCustomerCategory(customerCategory);

    let orderD = dateFormat(orderResponseData.OrderDate);
    setOrderDate(orderD)
    setPoNumber(orderResponseData.PurchaseOrder)
    setOrderNotes(orderResponseData.OrderNotes)
    setDeliveryInstructions(orderResponseData.DeliveryInstructions)
    let od = [];
    orderResponseData.tblOrderDetails.forEach(async (item) => {
      let productDetails = item.tblProduct?.tblProductDetails || [];

      let unitL = [];
      let classL = [];
      let sizeL = [];

      productDetails.forEach((detail) => {
        let commonObj = {
          DefAgentID: detail.DefAgentID,
          RRP: parseFloat(detail.RRP || 0),
          SellPrice: parseFloat(detail[`Sell${customerCategory}`] || 0),
          BuyPrice: parseFloat(detail.Cost || 0),
          Count: parseInt(detail.Wgt || 0),
        };

        if (detail.DefUnitID !== null) {
          let unit = unitListData.find((u) => u.value === detail.DefUnitID);
          unitL.push({ label: unit?.label || "", value: detail.DefUnitID, ...commonObj });
        }
        if (detail.DefClass !== null) {
          classL.push({ label: detail.DefClass, value: detail.DefClass, ...commonObj });
        }
        if (detail.DefSize !== null) {
          sizeL.push({ label: detail.DefSize, value: detail.DefSize, ...commonObj });
        }
      });
      let sellPrice = item.SellPrice;
      let buyPrice = item.BuyPrice;
      let count = item.Count;

      if (customerData) {
        let unitData = unitL?.find(unit => unit.value == item.UnitID)
        sellPrice = unitData?.SellPrice;
        buyPrice = unitData?.BuyPrice;
        count = unitData?.Count;
      }

      if (item?.ProductCode == "*" || item?.ProductCode == "**") {
        unitL = unitListData
      }
      
      od = [...od, {
        ODID: item.ODID,
        ProductID: item.ProductID,
        ProductCode: item.ProductCode,
        ProductName: item.ProductName,
        Qty: addTrailingZeros(item.Qty),
        ClassName: item.ClassName,
        SizeName: item.SizeName,
        UnitID: item.UnitID,
        AgentID: item.AgentID,
        units: unitL,
        classList: classL,
        sizes: sizeL,
        RRP: parseFloat(item.RRP || 0),
        SellPrice: parseFloat(sellPrice || 0),
        LastSellPU: parseFloat(item.LastSellPU || 0),
        BuyPrice: parseFloat(buyPrice || 0),
        Count: parseInt(count || 0),
      }]
    })
    setOrderDetails(od);
  }

  const formatDataForWarehouse = () => {

    let data = [];
    if (orderItemsList.length > 0) {
      orderItemsList.forEach((details, index) => {
        let newObj = {};
        newObj.ProductID = details.ProductID;
        newObj.ProductName = details.ProductName;
        newObj.Qty = details.Qty;
        newObj.ClassName = details.ClassName;
        newObj.ProductCode = details.ProductCode;
        newObj.RRP = details.RRP;
        newObj.SizeName = details.SizeName;
        newObj.SellPrice = details.SellPrice;
        newObj.LastSellPU = details.LastSellPU;
        newObj.IgnoreCrate = details.IgnoreCrate;
        // setting unit
        let unitItem = details.units?.find((unitItem) => unitItem.value == parseInt(details.UnitID));
        if (unitItem !== undefined) {
          newObj.tblUnit = { UnitID: parseInt(unitItem.value), UnitName: unitItem.label }
        }


        let agent = agents?.find((item) => item.value == details.AgentID);
        if (agent !== undefined) {
          newObj.tblAgent = { AgentCode: agent.label, AgentID: agent.value };
        }


        //setting customer 
        newObj.tblOrder = {
          CustomerID: customerId,
          OrderDate: orderDate,
          tblCustomer: {
            CustomerCode: customerCodeValue.CustomerCode,
            BuyerCode: customerCodeValue.BuyerCode
          }

        }
        // Push newly created obj to array
        data.push(newObj);
      });
      // pass new Data array to warehousesheet generation function to get warehousesSheet
      let warehouseData = convertDataToWarehouseSheet(data);
      let totalCustomersProducts = 0;

      warehouseData = warehouseData.map((data) => {
        const newObj = { ...data, TotalProducts: data.products.length - data.addBlankRows }
        totalCustomersProducts += data.products.length;
        return newObj;

      });;
      //  setWarehouseSheetData([...warehouseData]);
      // generate Warehouse sheet
      generateWarehousePdf(warehouseData);
    }
  }

  const editOrder = async (e) => {
    e.preventDefault();

    let URL = process.env.REACT_APP_API_URL + "/update-order";

    if (customerNameValue.length == 0 || customerCodeValue === "") {
      setCustomeCodeErr(true);
      return false;
    }

    if (orderItemsList.length == 0) {
      setOrderDErr(true);
      return false;
    }

    let updatedOrderItems = JSON.parse(JSON.stringify(orderItemsList));
    updatedOrderItems?.map((item) => {
      delete item.classList
      delete item.sizes
      delete item.units
      return item
    });
    
    let payload = {
      OrderDate: orderDate,
      PurchaseOrder: poNumber,
      DeliveryInstructions: deliveryInstructions,
      OrderNotes: orderNotes,
      CustomerID: customerId,
      OrderID: id,
      OrderDetails: updatedOrderItems,
    };
    setDisabledBtn(true);
    setMessage('');
    setMessageType('');

    let response = await POSTREQUEST(URL, payload, user.jwtToken);
    if (response?.data) {
      if (response.data?.success) {
        setMessage(response.data?.message);
        setMessageType('success');
      } else {
        setMessage(response.data?.message);
        setMessageType('error');
      }
      setDisabledBtn(false);
    }
    else {
      setMessage(response?.error?.message || 'Failed to update Order.');
      setMessageType('error');
      setDisabledBtn(false);
    }
  };

  const handleOrderDetailsChange = (newOrderDetails) => {
    setOrderItemsList(newOrderDetails);
  };

  const handleDelete = async () => {
    setShowDeleteOrderModal(false);
    setMessageType('')
    setMessage('')
    let URL =
      process.env.REACT_APP_API_URL + "/delete-order/" + id;
    let response = await GETREQUEST(URL, user.jwtToken);
    if (response?.data) {
      if (response.data?.success) {
        setMessage(response.data?.message);
        setMessageType('success');
        setTimeout(() => {
          navigate("/all-orders");
        }, 2000);
      } else {
        setMessage(response.data?.message);
        setMessageType('error');
      }
    }
    else {
      setMessage(response?.error?.message || 'Failed to delete product !!');
      setMessageType('error');
    }
  }

  const handleCustomerCodeChange = async (value) => {
    let redirectOrderId = value?.tblOrders[0]?.OrderId || null;
    if (redirectOrderId) {
      let orderUrl = process.env.REACT_APP_API_URL + "/get-order/" + redirectOrderId;
      let orderResponse = await GETREQUEST(orderUrl, user.jwtToken);
      navigate(`/view-edit-order/${redirectOrderId}`)
      setOrderDetailsData(orderResponse?.data);
      await onCustomerChange(orderResponse?.data, units);
      await fetchProducts(value.CustomerID)
      return
    }
    setCustomeCodeErr(false);
    await onCustomerChange(orderDetailsData, units, value)
    await fetchProducts(value.CustomerID)
  };

  return (
    <React.Fragment>
      {showDeleteOrderModal && <DeleteItemModal modal={showDeleteOrderModal} handleDelete={handleDelete} setModal={setShowDeleteOrderModal} title={"Delete Order ?"} text={"Do you want to delete this order ?"} />}
      <Header />
      {message && <Toastify message={message} type={messageType} />}
      <main className="bg-lite-grey overflow-auto">
        <section className="px-4 pt-3 pb-4 overflow-hidden table-listing">
          <div className="table-elements">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item fs-15">
                  <Link
                    to="/all-orders"
                    className="text-decoration-none text-primary"
                  >
                    Orders
                  </Link>
                </li>
                <li
                  className="breadcrumb-item fs-15 active"
                  aria-current="page"
                >
                  View/Edit
                </li>
              </ol>
            </nav>
          </div>
          <div className="card border-bottom-0">
            <div className="card-header bg-white d-flex align-items-center justify-content-between cpx-20 cpy-14 sticky-top flex-nowrap">
              <h1 className="title-semibold fs-24 mb-0 d-flex align-items-center text-nowrap me-5 me-xl-0">
                View/Edit Order
              </h1>
              <div className="filter-elements d-flex align-items-center">
                <div className="custom-group flex-nowrap mb-xl-0">
                  <label
                    htmlFor=""
                    className="pe-2 d-flex align-items-center fs-14 text-lite"
                  >
                    Code:
                  </label>
                  <div className="date position-relative cme-15">
                    <Select
                      className={customeCodeErr ? "react-select-invalid" : ""}
                      value={customerCodeValue}
                      isSearchable={true}
                      styles={customStyles}
                      options={customersCode}
                      placeholder="Select Code"
                      onChange={(e) => handleCustomerCodeChange(e)}
                      components={{ Option: CustomOption }}
                    />
                  </div>
                </div>
                <div className="custom-group flex-nowrap">
                  <label
                    htmlFor=""
                    className="pe-2 d-flex align-items-center fs-14 text-lite"
                  >
                    Customer:
                  </label>
                  <div className="date position-relative cme-15">
                    <input
                      type="text"
                      className="form-control input-sm"
                      placeholder="Customer"
                      value={customerNameValue}
                      style={{ width: "360px" }}
                      disabled
                    />
                  </div>
                </div>
                <div className="custom-group flex-nowrap mb-lg-0">
                  <label
                    htmlFor=""
                    className="pe-2 d-flex align-items-center fs-14 text-lite"
                  >
                    Ship date:
                  </label>
                  <div className="position-relative" data-provide="datepicker">
                    <input
                      type="date"
                      id="datepicker"
                      className="form-control input-sm date input-datepicker"
                      placeholder="Select Date"
                      defaultValue={orderDate}
                      onChange={(e) => {
                        setOrderDate(e.target.value);
                        setIsFetchCustomer(true);
                      }}
                    />
                  </div>
                </div>
              </div>
              <div></div>
            </div>

            <div className="card-body p-4 border-bottom">

              <div className="card-table table-responsive">
                <table className="table table-form disable-field">
                  <thead>
                    <tr>
                      <td scope="col" className="width-lg-8">
                        Prod. Code
                      </td>
                      <td scope="col" className="width-lg-42">
                        Product name
                      </td>
                      <td scope="col" className="width-lg-10">
                        Qty
                      </td>
                      <td scope="col" className="width-lg-10">
                        Unit
                      </td>
                      <td scope="col" className="width-lg-10">
                        Class
                      </td>
                      <td scope="col" className="width-lg-10">
                        Size
                      </td>
                      <td scope="col" className="width-lg-10">
                        Agent
                      </td>
                    </tr>

                  </thead>
                  <tbody>
                    {orderDetails.length > 0 && <EnterOrderList isCustomerSelect={customerId == ''} orderDetails={orderDetails} customerCategory={customerCategory} products={products} agents={agents} units={units} handleOrderDetailsChange={handleOrderDetailsChange} />}
                  </tbody>
                </table>

              </div>
              {orderDErr && (
                <div className="text-danger text-center">
                  {" "}
                  Please add at least one order detail.{" "}
                </div>
              )}
              <div className="col d-flex width-lg-10 gap-1 mt-2">
                <label className="d-flex align-items-center justify-content-end fs-14 text-lite text-nowrap">
                  Items :
                </label>
                <input
                  type="text"
                  className="form-control input-sm text-end"
                  placeholder="0"
                  value={orderItemsList.length}
                  disabled
                />
              </div>
              <div className="spacer-sm-4"></div>
              <form onSubmit={editOrder}>
                <div className="row">
                  <div className="col-xl-3 col-lg-4 mb-lg-0 mb-4 flex-grow-1 flex-xl-grow-0">

                    <div className="cmb-10 row gx-3 gy-2">
                      <label className="col-xl-3 d-flex align-items-center fs-14 text-lite text-nowrap justify-content-xl-end">
                        Buyer Code:
                      </label>
                      <div className="col">
                        <input
                          type="text"
                          className="form-control input-sm"
                          placeholder="Buyer Code"
                          value={BuyerCode}
                          disabled
                        />
                      </div>
                    </div>
                    <div className="cmb-10 row gx-3 gy-2">
                      <label className="col-xl-3 d-flex align-items-center fs-14 text-lite text-nowrap justify-content-xl-end">
                        Contact:
                      </label>
                      <div className="col">
                        <input
                          type="text"
                          className="form-control input-sm"
                          placeholder="Contact"
                          value={contactName}
                          disabled
                        />
                      </div>
                    </div>
                    <div className="cmb-10 row gx-3 gy-2">
                      <label className="col-xl-3 d-flex align-items-center fs-14 text-lite text-nowrap justify-content-xl-end">
                        Phone No:
                      </label>
                      <div className="col">
                        <input
                          type="text"
                          className="form-control input-sm"
                          placeholder="Phone number"
                          value={phoneNo}
                          disabled
                        />
                      </div>
                    </div>
                    <div className="cmb-10 row gx-3 gy-2">
                      <label className="col-xl-3 d-flex align-items-center fs-14 text-lite text-nowrap justify-content-xl-end">
                        Purchase Order:
                      </label>
                      <div className="col">
                        <input
                          type="text"
                          className={
                            "form-control input-sm "
                          }
                          placeholder="Purchase order"
                          onChange={(e) => {
                            setPoNumber(e.target.value);
                          }}
                          defaultValue={poNumber}
                        />
                      </div>
                    </div>

                  </div>
                  <div className="width-lg-20 width-sm-50 flex-grow-1 flex-xl-grow-0">
                    <label className="d-flex align-items-center fs-15 text-dark mb-1">
                      Order Notes
                    </label>
                    <textarea
                      className={
                        "form-control fw-normal fs-15 fst-italic "
                      }
                      rows="3"
                      style={{ minHeight: "81%" }}
                      onChange={(e) => {
                        setOrderNotes(e.target.value);
                      }}
                      defaultValue={orderNotes}
                      placeholder="Enter notes"
                    />

                  </div>
                  <div className="width-lg-20 width-sm-50 flex-grow-1 flex-xl-grow-0">
                    <label className="d-flex align-items-center fs-15 text-dark mb-1">
                      Delivery Instructions
                    </label>
                    <textarea
                      className={
                        "form-control fw-normal fs-15 fst-italic "
                      }
                      placeholder="Enter delivery instructions"
                      rows="3"
                      onChange={(e) => {
                        setDeliveryInstructions(e.target.value);
                      }}
                      style={{ minHeight: "81%" }}
                      defaultValue={deliveryInstructions}
                    />
                  </div>
                  <div className="col d-flex justify-content-end align-items-end mt-4 mt-lg-0">
                    <a
                      role="button"
                      className="btn btn-md btn-outline-danger d-flex align-items-center px-4 fw-medium rounded-3 mx-1 text-nowrap"
                      onClick={() => setShowDeleteOrderModal(true)}
                    >
                      Delete Order
                    </a>

                    <button disabled={orderItemsList.length === 0} type="button"
                      className={`btn btn-outline-secondary btn-md ms-auto d-flex align-items-center px-4 fw-medium rounded-3 mx-1 ${orderItemsList.length > 0 ? "" : "disabled"}`}
                      onClick={() => { formatDataForWarehouse() }}
                    >
                      Preview
                    </button>
                    <button
                      type="submit"
                      className="btn btn-md btn-secondary d-flex align-items-center px-4 fw-medium text-white rounded-3 mx-1 text-nowrap"
                      disabled={disabledBtn}
                    >
                      Update Order
                    </button>

                  </div>

                </div>
              </form>
            </div>

          </div>
        </section>
      </main>
    </React.Fragment>
  );
}

export default ViewEditOrder;
